const FullDashboard = () => import("./main");

export default [{
  name: "home",
  path: "/",
  component: FullDashboard
}];
